module.exports = {
  STARTING_TIER: 1.8,
  SPACE_RACE_STARTING_TIER: 2.0
};
